var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBottomSahpe({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 659.33,
    height: 465.387,
    viewBox: "0 0 659.33 465.387",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{clip-path:url(#a);}.c{fill:#f9c52d;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 659.33,
    height: 361.387,
    rx: 6,
    transform: "translate(678 484)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-684 -338)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(6 -146)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M574.618,639.2s26.165-44.921,145.747-36.428,133.724,21.841,231.776,4.37,153.488,12.482,199.989,12.739,95.476-24.242,95.476-24.242V646.4Z",
    transform: "translate(89.723 212.84)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 659.33,
    height: 113.387,
    rx: 6,
    transform: "translate(684 690)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomSahpe);
export default __webpack_public_path__ + "static/media/bottom_sahpe.cf8f8d416eb028fd3310b56e8a98178d.svg";
export { ForwardRef as ReactComponent };